import https from '@sg/utils/httpC';

// COS response type (copied from @gp/types/global)
export interface QCouldResTypes {
  // COS Region
  region: string;
  // COS Bucket 存储桶
  bucket: string;
  // COS TmpSecretId
  tmp_secret_id: string;
  // COS TmpSecretKey
  tmp_secret_key: string;
  // COS SecurityToken
  session_token: string;
}

/**
 * 获取bids存储桶信息，广州
 * @param uploadFolderName - 上传文件夹名称（路径），用于获取对应路径的secret key
 * @returns COS配置信息
 */
export const getBIDSTencentQCouldMassage = (uploadFolderName?: string): Promise<QCouldResTypes> => {
  return https({
    url: '/api/v1/globalpedia_pc/studio_management/tencent_qcloud/auth',
    method: 'get',
    params: uploadFolderName ? { path: uploadFolderName } : {},
  }) as Promise<QCouldResTypes>;
};

